import React from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter, Route} from 'react-router-dom';
import SessionCheckContainer from './components/SessionCheckContainer/SessionCheckContainer';
import BirdhouseContainer from './components/BirdhouseContainer/BirdhouseContainer';

/**
 * Basic provider wrapping. This has been externalized in order to
 * enable hot module replacement features.
 */

/* istanbul ignore next */
function Root({store, siteContext}) {
    return (
        <Provider store={store}>
            <BrowserRouter basename={siteContext.basePath}>
                <div>
                    <Route path="/auth/ui/sessionCheck" component={SessionCheckContainer}/>
                    <Route path="/auth/ui/login" component={BirdhouseContainer}/>
                    <Route path="/auth/ui/resetPassword" component={BirdhouseContainer}/>
                    <Route path="/auth/ui/confirmEmail" component={BirdhouseContainer}/>
                </div>
            </BrowserRouter>
        </Provider>
    );
}

export default Root;
